









import { Component, Vue } from 'vue-property-decorator'

import Header from '@/components/header'

@Component({
  components: {
    Header
  }
})
export default class MainLayout extends Vue {
  navList = [
    { name: 'courseIndex', title: '云端课程', icon: 'cloud' },
    { name: 'courseMy', title: '我的课程', icon: 'read' },
    { name: 'courseEdit', title: '创建课程', icon: 'appstore' }
    // { name: 'classIndex', title: '进入课堂',icon: "login" /> }
  ]


  get nav() {
    const nav = this.$route.meta.nav || this.$route.name
    return nav
  }

  // 是否为嵌入模式，目前只有 class header 使用
  get embed() {
    const embed = !!this.$route.meta.embed
    return embed
  }

  get fullMain() {
    return !!this.$route.meta.fullMain
  }

  get i18n() {
    const value = this.$t('login')
    return value as any
  }
  created() {

  }
  mounted() {
    if (this.embed) {
      this.$router.beforeEach((to, from, next) => {
        const parent = window.parent
        if (parent) {
          parent.location.href = to.fullPath
          return
        }
        next(to)
      })
    }
  }
}
